import { ApiEndpointUrl } from "../../common";
export const bannerPoint = { list: ApiEndpointUrl + "getbanner" };
